<template>
  <modal
      :show="showModal"
      :action-text="__('mistakes.mark_as_learned')"
      :show-action-btn="true"
      :btn-class="'btn-success'"
      @close="$emit('close')"
      @action-clicked="markMistakeAsLearned">

    <div class="p-2 lg:p-4 sm:text-left">
      <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">Details zur Prüfungsfrage</h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500 mb-2" v-html="mistake.question.text"></p>
        <table class="w-full text-sm text-left text-gray-500">
          <tbody>
          <tr class="bg-white border-b">
            <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50">
              Wie oft richtig beantwortet?
            </th>
            <td class="p-2 lg:py-4 lg:px-6 text-right">
              {{ mistake.times_right }}
            </td>
          </tr>
          <tr class="bg-white border-b">
            <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50">
              Wie oft falsch beantwortet?
            </th>
            <td class="p-2 lg:py-4 lg:px-6 text-right">
              {{ mistake.times_wrong }}
            </td>
          </tr>
          <tr class="bg-white border-b">
            <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50">
              Das letzte Mal geübt am:
            </th>
            <td class="p-2 lg:py-4 lg:px-6 text-right">
              {{ moment(moment.last_learned_at).format('DD.MM.YYYY HH:mm') }}
            </td>
          </tr>
          <tr class="bg-white border-b">
            <th scope="row" class="p-2 lg:p-4 text-xs text-gray-700 uppercase bg-gray-50">
              Tendenz
            </th>
            <td class="p-2 lg:py-4 lg:px-6 text-right">
              <tendency :value="mistake.tendency" />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../Modal'
import Tendency from './Tendency'
import moment from 'moment'

export default {

  name: 'MistakeModal',

  components: {
    Tendency,
    Modal,
  },

  props: {
    mistake: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  emits: ['toggle', 'close', 'mistake-learned'],

  data() {
    return {
      moment: moment,
    }
  },

  methods: {
    markMistakeAsLearned: function() {
      this.$emit('mistake-learned', this.question )
      this.$emit('close')
    },
  },
}
</script>

<style scoped>

</style>